import {I18n} from 'aws-amplify/utils';
import {
    Alert,
    Container,
    Title,
} from '@mantine/core';

// FNP-1186 placeholder. The real module is FNP-1191, which replaces this file
// with the page and adds the rest of the module inside this directory. The
// route, nav entry and RBAC actions are already registered, so FNP-1191 does
// not touch the shared configuration files again.
export const PlaceholderPage = () => {
    return (
        <Container p={'xl'}>
            <Title order={2} mb={'md'}>{I18n.get('Zones')}</Title>
            <Alert title={I18n.get('Not built yet')}>
                {I18n.get('This module is registered but not yet implemented. It arrives with FNP-1191.')}
            </Alert>
        </Container>
    );
};
